var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWellbeing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 60C45.7917 60 59 46.3402 59 29.4915L-1.31134e-06 29.4915C-5.87137e-07 46.3402 13.2083 60 29.5 60Z",
    fill: "#E69177"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 30.5085C46.7917 30.5085 60 16.8488 60 7.17639e-05L0.999999 7.43866e-05C0.999999 16.8488 14.2083 30.5085 30.5 30.5085Z",
    fill: "#FFD9CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWellbeing);
export default __webpack_public_path__ + "static/media/Wellbeing.6d1d25c613294f8e70f01a422e9f3ed3.svg";
export { ForwardRef as ReactComponent };